import { render, staticRenderFns } from "./huaRecord.vue?vue&type=template&id=ece2109c&"
import script from "./huaRecord.vue?vue&type=script&lang=js&"
export * from "./huaRecord.vue?vue&type=script&lang=js&"
import style0 from "./huaRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports